// extracted by mini-css-extract-plugin
export default {"panelWrapper":"DocumentSearchSidePanel_panelWrapper__7RC+B"};